<mat-grid-list cols="1" rowHeight="35px">
  <mat-grid-tile rowspan="1">
    <h1 class="title">Rangos</h1>
  </mat-grid-tile>
  <mat-grid-tile rowspan="2">
    <button mat-raised-button color="accent" (click)="openCreate()" style="margin-right: 10px" appPermissionControl="P194B0001"><mat-icon>add</mat-icon> Nuevo</button>
    <button mat-raised-button color="accent" (click)="close()" appPermissionControl="P194B0002"><mat-icon>close</mat-icon> Cerrar</button>
  </mat-grid-tile>
  <mat-grid-tile rowspan="2">
    <mat-form-field color="accent" appearance="outline">
      <mat-label>Buscar</mat-label>
      <input matInput (keyup)="applyFilter($event.target.value)" placeholder="Ej. Promocional" #input appPermissionControl="P194K0001" />
      <mat-icon matSuffix color="accent">search</mat-icon>
    </mat-form-field>
  </mat-grid-tile>
</mat-grid-list>

<div id="div" class="mat-elevation-z8 table-responsive">
  <table mat-table [dataSource]="dataSource" matSort appPermissionControl="P194T0001">
    <ng-container matColumnDef="actions">
      <th mat-header-cell *matHeaderCellDef appPermissionControl="P194C0001">Acciones</th>
      <td mat-cell *matCellDef="let element">
        <button mat-icon-button [matMenuTriggerFor]="menu" appPermissionControl="P194B0003">
          <mat-icon>more_vert</mat-icon>
        </button>
        <mat-menu #menu="matMenu">
          <button (click)="openUpdate(element)" mat-menu-item appPermissionControl="P194B0004">
            <mat-icon>edit</mat-icon>
            <span>Editar</span>
          </button>
          <button (click)="delete(element)" mat-menu-item appPermissionControl="P194B0005">
            <mat-icon>delete</mat-icon>
            <span>Eliminar</span>
          </button>
        </mat-menu>
      </td>
    </ng-container>

    <ng-container matColumnDef="clavePerfil">
      <th mat-header-cell *matHeaderCellDef mat-sort-header appPermissionControl="P194C0002">Clave</th>
      <td mat-cell *matCellDef="let element">
        {{ element.clavePerfil }}
      </td>
    </ng-container>

    <ng-container matColumnDef="variable">
      <th mat-header-cell *matHeaderCellDef mat-sort-header appPermissionControl="P194C0003">Variable</th>
      <td mat-cell *matCellDef="let element">
        {{ element.variable }}
      </td>
    </ng-container>

    <ng-container matColumnDef="rango1">
      <th mat-header-cell *matHeaderCellDef mat-sort-header appPermissionControl="P194C0004">Rango 1</th>
      <td mat-cell *matCellDef="let element">
        {{ element.rango1 }}
      </td>
    </ng-container>

    <ng-container matColumnDef="rango2">
      <th mat-header-cell *matHeaderCellDef mat-sort-header appPermissionControl="P194C0005">Rango 2</th>
      <td mat-cell *matCellDef="let element">
        {{ element.rango2 }}
      </td>
    </ng-container>

    <ng-container matColumnDef="valorStr">
      <th mat-header-cell *matHeaderCellDef mat-sort-header appPermissionControl="P194C0006">Valor Str</th>
      <td mat-cell *matCellDef="let element">
        {{ element.valorStr }}
      </td>
    </ng-container>

    <ng-container matColumnDef="politica">
      <th mat-header-cell *matHeaderCellDef mat-sort-header appPermissionControl="P194C0007">Politica</th>
      <td mat-cell *matCellDef="let element">
        {{ element.politica }}
      </td>
    </ng-container>

    <ng-container matColumnDef="comentario">
      <th mat-header-cell *matHeaderCellDef mat-sort-header appPermissionControl="P194C0008">Comentario</th>
      <td mat-cell *matCellDef="let element">
        {{ element.comentario }}
      </td>
    </ng-container>

    <ng-container matColumnDef="siguiente">
      <th mat-header-cell *matHeaderCellDef mat-sort-header appPermissionControl="P194C0009">Siguiente</th>
      <td mat-cell *matCellDef="let element">
        {{ element.siguiente }}
      </td>
    </ng-container>

    <ng-container matColumnDef="score">
      <th mat-header-cell *matHeaderCellDef mat-sort-header appPermissionControl="P194C0010">Score</th>
      <td mat-cell *matCellDef="let element">
        {{ element.score }}
      </td>
    </ng-container>

    <ng-container matColumnDef="rango">
      <th mat-header-cell *matHeaderCellDef mat-sort-header appPermissionControl="P194C0011">Rango</th>
      <td mat-cell *matCellDef="let element">
        {{ element.rango }}
      </td>
    </ng-container>

    <tr mat-header-row *matHeaderRowDef="columns"></tr>
    <tr mat-row *matRowDef="let row; columns: columns"></tr>

    <tr class="mat-row" *matNoDataRow>
      <td class="mat-cell" colspan="20">
        <span *ngIf="allData > 0">No hay resultados para "{{ input.value }}"</span>
        <span *ngIf="allData == 0 && !loading">No hay datos para mostrar</span>
        <mat-spinner *ngIf="loading" class="spinner"></mat-spinner>
      </td>
    </tr>
  </table>
  <mat-paginator [pageSizeOptions]="[5, 10, allData]" showFirstLastButtons class="paginatorTb"></mat-paginator>
</div>
